import { useUiContext } from "@rotorstudios/fe-ui";
import { CAVQtvrAssets } from "@rotorstudios/configurable-asset-visualiser";

import useCmeAssetsBreakpointFallback from "../../modules/fe-cme/useAssetsBreakpointFallback";
import { useDataContext } from "../../modules/Data/DataProvider";

type iProps = {
  assetSet?: string;
};

const useUiMCMEQtvr = ({ assetSet }: iProps) => {
  const { breakpointActive, projectClass, isMobile } = useUiContext();
  const { modalState } = useDataContext();
  const { cmeAssets } = useCmeAssetsBreakpointFallback(
    assetSet ?? modalState.data?.assetSet,
  );

  const getData = () => cmeAssets as any as CAVQtvrAssets;

  return {
    breakpointActive,
    scrollZoom: isMobile,
    projectClass,
    assets: getData(),
  };
};

export default useUiMCMEQtvr;
